import type { Route, Router } from '@paperbits/common/routing';

export class CustomHistoryRouteHandler {

  private internalPushState: (data: any, title: string, url: string) => void;

  constructor(private readonly router: Router) {
      this.internalPushState = history.pushState;
      history.pushState = this.externalPushState.bind(this);
      this.onRouteChange = this.onRouteChange.bind(this);
      router.addRouteChangeListener(this.onRouteChange);
      router.addHistoryUpdateListener(this.onRouteChange);
      window.addEventListener('popstate', this.onPopState.bind(this));
  }

  private onPopState(_event: PopStateEvent): void {
      const url = location.pathname + location.hash;
      this.router.navigateTo(url);
  }

  /**
   * Intercepts external pushState invocations.
   */
  private externalPushState(route: Route, title?: string, href?: string): void {
    if (href?.includes('/cms') || href?.includes('/approval')) {
      this.internalPushState.call(history, route, title, href);
      return;
    }
    // this.router.navigateTo(route.url);
  }

  /**
   * Handles internal router event.
   */
  private onRouteChange(route: Route): void {
      this.internalPushState.call(history, route, route.title, route.url);
  }
}